import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Location } from "@angular/common";
import { CommonHttpService } from "src/app/shared/services/common-http/common-http.service";
import { MessageService } from "src/app/shared/services/message/message.service";
import { DefaultLanguageId, devicePixelRatio } from "src/app/shared/constants";
import { includes, forEach, sortBy } from "lodash";
import { Subscription } from "rxjs";
import {
  AllFiltersModel,
  CompanyFilterModel,
} from "src/app/company/people/shared/models/profile-models";
import { UntypedFormControl } from "@angular/forms";
import { SendIframeUrlService } from "src/app/shared/services/send-iframe-url/send-iframe-url.service";

@Component({
    selector: "app-copy-page-template",
    templateUrl: "./copy-page-template.component.html",
    styleUrls: ["./copy-page-template.component.scss"],
    standalone: false
})
export class CopyPageTemplateComponent implements OnInit {
  devicePixelRatio = devicePixelRatio;
  companyId: number;
  pageId: number;
  playbookId: number;
  isDraftMode: boolean;
  templateName: string;
  selectedFile: any;
  description: string;
  popoverSearch: string;
  previewImage: any;
  templateGroups = [];
  selectedGroup = "";
  confirmationModalRef: BsModalRef;
  confModalSubsciber: Subscription;
  includeResources = false;
  includeLanguages = false;
  isMobileFriendly = false;
  imageAllowedExtensions = ["jpg", "png", "jpeg"];
  profile;
  allCompanies: Array<CompanyFilterModel> = [];
  nonSelectedCompanies: Array<CompanyFilterModel> = [];
  selectedCompanies: Array<any> = [];
  companiesId: Array<any> = [];
  companies = new UntypedFormControl("");
  isAllCompaniesAssigned = false;
  constructor(
    private modalRef: BsModalRef,
    private commonHttpService: CommonHttpService,
    private messageService: MessageService,
    private location: Location,
    private sendIframeUrlService: SendIframeUrlService
  ) {}

  ngOnInit() {
    if (this.profile.role !== "SuperVPlaybookAdmin") {
      this.commonHttpService
        .get({
          uri: `/api/PageTemplates/GetCompanyDefaultPageTemplateGroup?companyId=${this.companyId}`,
        })
        .subscribe((response: any) => {
          this.selectedGroup = response;
        });
    }
    if (this.profile.role == "SuperVPlaybookAdmin") {
      this.getGroups();
      this.getAllCompanies();
      this.onFormChanges();
    }
  }

  groupChange(id) {
    if (id == "") {
      this.companies.setValue("");
      this.companies.enable({ emitEvent: false });
      return;
    }
    const selectedGroup = this.templateGroups.find((group) => group.id == +id);
    if (!selectedGroup.isGlobalGroup) {
      this.companies.setValue("");
      this.selectedCompanies = [];
      this.nonSelectedCompanies = this.allCompanies;
      this.companiesId = [];
      this.companies.disable({ emitEvent: false });
    } else {
      this.companies.enable({ emitEvent: false });
    }
  }

  // For monitoring value change in the dropdown values for cascading controls
  onFormChanges() {
    this.companies.valueChanges.subscribe((val) => {
      this.isAllCompaniesAssigned = false;
      if (+val == -1) {
        this.isAllCompaniesAssigned = true;
        this.selectedCompanies = [];
        this.nonSelectedCompanies = this.allCompanies;
        this.companiesId = [];
      } else if (val) {
        const selecteCompany = this.allCompanies.find(
          (item) => item.id === +val
        );
        if (selecteCompany) {
          this.selectedCompanies.push(selecteCompany);
          this.companiesId.push(+val);
          this.nonSelectedCompanies = this.nonSelectedCompanies.filter(
            (comp) => !(+val === comp.id)
          );
        } else {
          this.nonSelectedCompanies = this.allCompanies.filter(
            (comp) =>
              !this.selectedCompanies.find((item) => item.id === comp.id)
          );
        }
      }
    });
  }
  // Remove company from selected company list
  removeCompany(companyId) {
    // removing from companies
    const index = this.companiesId.indexOf(+companyId);
    this.companiesId.splice(index, 1);

    // For display list and non selected list
    this.selectedCompanies = this.allCompanies.filter((comp) =>
      this.companiesId.includes(comp.id)
    );
    this.nonSelectedCompanies = this.allCompanies.filter(
      (comp) => !this.companiesId.includes(comp.id)
    );
    this.companies.setValue("", { emitEvent: false });
  }

  getAllCompanies() {
    this.commonHttpService
      .get<AllFiltersModel>({
        uri: "/api/Profiles/GetAllFilters?includePlaybooks=false&includeAllPlaybooks=false&includeDraftPlaybooks=false&includeAllCompanies=true",
      })
      .subscribe((response) => {
        this.allCompanies = sortBy(
          response.allCompanies,
          (eachCompany) => eachCompany.name
        );
        this.nonSelectedCompanies = this.allCompanies;
      });
  }
  /**
   * To fetch template groups
   */
  getGroups() {
    this.commonHttpService
      .get({
        uri: "/api/PageTemplates/GetAllPageTemplateGroups",
      })
      .subscribe((response: any) => {
        this.templateGroups = sortBy(response, ["name"]);
        if (response.length) {
          // setting order for group select popover
          let order = 0;
          forEach(this.templateGroups, (group) => {
            group.order = order;
            order++;
          });
        }
      });
  }

  /**
   * To handle file change event and upload image for preview image
   * @param event change event
   */
  fileChangeEvent(event: any) {
    if (event.target.files[0] !== undefined) {
      this.selectedFile = event.target.files[0];
      const isValidExtension = this.checkExtension(this.imageAllowedExtensions);
      if (isValidExtension) {
        const formData: FormData = new FormData();
        formData.append("file", this.selectedFile);
        this.commonHttpService
          .post({
            uri: "/api/Assets/UploadImage",
            object: formData,
          })
          .subscribe((response: any) => {
            this.previewImage = response;
          });
      } else {
        const isAre = this.imageAllowedExtensions.length > 1 ? "are" : "is";
        const extensionErrorMessage =
          "This is not a valid extension. Supported extension(s) " +
          isAre +
          " : " +
          this.imageAllowedExtensions.join(",") +
          ".";
        this.messageService.showErrorMessage(extensionErrorMessage);
      }
    }
  }

  /**
   * To validate extension of uploaded file
   * @param allowedExtensions allowed extension values
   */
  checkExtension(allowedExtensions) {
    const fileExtension = this.selectedFile.name.split(".");
    const extension = fileExtension[fileExtension.length - 1].toLowerCase();
    const isValidExtension = includes(allowedExtensions, extension);
    return isValidExtension;
  }

  /**
   * To create page template
   * @param isFormValid form valid check flag
   */
  addPageTemplate(isFormValid) {
    if (isFormValid) {
      const reqObj = {
        pageId: this.pageId,
        name: this.templateName,
        previewImageKey: this.previewImage ? this.previewImage.id : null,
        description: this.description,
        includeResources: this.includeResources,
        includeLanguages: this.includeLanguages,
        isMobileFriendly: this.isMobileFriendly,
        isDraftMode: this.isDraftMode,
        groupId: this.selectedGroup == "" ? null : +this.selectedGroup,
        originCompanyId: this.companyId,
        companyIds:
          this.profile.role == "SuperVPlaybookAdmin" ? this.companiesId : [],
        isAllCompaniesAssigned:
          this.isAllCompaniesAssigned && this.companiesId.length == 0,
      };
      this.commonHttpService
        .post({
          uri: "/api/PageTemplates/CreatePageTemplate",
          object: reqObj,
        })
        .subscribe((response) => {
          this.messageService.showSuccessMessage(
            "Page template successfully created."
          );
          this.closeModal();
        });
    }
  }

  /**
   * To close the modal
   */
  closeModal() {
    const returnUrl =
      window.location.pathname.replace("/pagetemplate", "") +
      "?languageId=" +
      DefaultLanguageId;
    this.location.go(returnUrl);
    this.sendIframeUrlService.sendUrlToParent(returnUrl);
    this.modalRef.hide();
  }
}
